"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const messageUtils = __importStar(require("./messageUtils"));
const BaseMessage_1 = require("./BaseMessage");
const ErrorMessageElement_1 = require("./internal/ErrorMessageElement");
const utils_1 = require("../../internal/utils");
const RED_A100 = "#ff8a80";
class ErrorMessage extends BaseMessage_1.BaseMessage {
    createMessageElementInternal() {
        return new ErrorMessageElement_1.ErrorMessageElement();
    }
    drawCellMessageInternal(_message, context, style, helper, grid, _info) {
        const { bgColor } = style;
        const { select } = context.getSelection();
        if (!utils_1.cellInRange(grid.getCellRange(context.col, context.row), select.col, select.row) ||
            !grid.hasFocusGrid()) {
            helper.drawBorderWithClip(context, (_ctx) => {
                messageUtils.drawExclamationMarkBox(context, {
                    bgColor: RED_A100,
                    color: bgColor,
                }, helper);
            });
        }
    }
}
exports.ErrorMessage = ErrorMessage;
